<div class="container-fluid">
  <app-header></app-header>
  <app-subheader></app-subheader>
  <div class="bg-primary bg-dark p-2">

    <div class="row p-2">

      <div class="col-md-6"><h4>CANALES DE COMUNICACION</h4>
        <h5>ADMINISTRACION</h5>
        <p class="text-secondary">(02922) 462079 / 462341 / 462768 interno 11/12</p>
        <p class="text-secondary">escritorio@antonioalfano.com.ar / antonioalfanoycia@gmail.com</p>

        <h5>ALMACEN</h5>
        <p class="text-secondary">(02922) 462079 / 462341 / 462768 interno 13/17</p>
        <p class="text-secondary">(02922) 462079 / 462341 / 462768 interno 18 (Carniceria)</p> 
        <p class="text-secondary">almacencolon@antonioalfano.com.ar</p>

        <h5>CORRALON</h5>
        <p class="text-secondary">(02922) 462329</p>
        <p class="text-secondary">corralon@antonioalfano.com.ar</p>

        <h5>FERRETERIA</h5>
        <p class="text-secondary">(02922) 462079 / 462341 / 462768 interno 14/15</p>
        <p class="text-secondary">ferreterias@antonioalfano.com.ar</p>

        <h5>REPARTO</h5>
        <p class="text-secondary">(02922) 462079 / 462341 / 462768 interno 20</p>
        <p class="text-secondary">pedidosweb@antonioalfano.com.ar</p>

      </div>

      <div class="col-md-4 float-right">
        <h4>MEDIOS DE PAGO</h4>
        <img src="./assets/images/logo_tarjetas.svg" width="300" height="400">
      </div>
    </div>
  </div>
</div>